import React from "react";
import logo from "./logo.svg";

import { ActionListPage, ActionIntroPage } from "./actions/pages/";
import { LoginPage, RegisterPage, ResetPasswordPage } from "./auth";
import { HomePage } from "./home/pages/HomePage";
import { NotFound } from "./common/components/NotFound";
import { Layout } from "./common/components/Layout";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./bootstrap-variables.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";
import { AuthProvider } from "./providers/authProvider";
import { LogoutPage } from "./auth/pages/LogoutPage";
import { PrivateRoutes } from "./common/components/withAuth";
import { useEffect } from "react";
import EventPage from "./event/pages/EventPage";
import ViewEventPage from "event/pages/ViewEventPage";
import CreateEventPage from "./event/pages/CreateEventPage";
import ProfilePage from "./profile/pages/ProfilePage";
import DashboardPage from "./dashboard/pages/DashboardPage";
import SettingsPage from "./settings/page/SettingsPage";
import EvidencePage from "./evidence/page/EviDencePage";
import EditEventPage from "event/pages/EditEventPage";
import ActionBoardPage from "./board/pages/ActionBoardPage";
import SdgSelectorPage from "./sdgselection/pages/SdgSelectorPage";
import SdgSelectedPage from "sdgselection/pages/SdgSelectedPage";
import EventReport from "event/pages/EventReport";
import GlobalActionPage from "admin/globalActions/pages/GlobalAction";
import BillingHome from "billing/pages/BillingHome";
import PaymentSuccess from "billing/pages/PaymentSuccess";
import { BillingManagement } from "billing/pages/BillingManagement";
import { BillingCancel } from "billing/pages/BillingCancel";
import { CookieConsent } from "privacy/cookies/CookieConsent";
import PrivacyPolicyPage from "privacy/pages/PrivacyPolicy";
import CookiesPolicyPage from "privacy/pages/CookiesPolicy";

function App() {
  useEffect(() => {}, []);
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route path='/actions-intro' element={<ActionIntroPage />} />
              <Route path='/actions' element={<ActionListPage />} />
              <Route path='/dashboard' element={<DashboardPage />} />
              <Route path='/settings' element={<SettingsPage />} />
              <Route path='/profile' element={<ProfilePage />} />
              <Route path='/event' element={<EventPage />} />
              <Route path='/event-report/:id' element={<EventReport />} />
              <Route path='/eventedit/:id' element={<EditEventPage />} />
              <Route path='/eventview/:id' element={<ViewEventPage />} />
              <Route path='/create-event' element={<CreateEventPage />} />
              <Route path='/actionboard' element={<ActionBoardPage />} />
              <Route path='/sdgselector' element={<SdgSelectorPage />} />
              <Route path='/sdgselected' element={<SdgSelectedPage />} />
              <Route path='/admin/globalaction' element={<GlobalActionPage />} />
              <Route path="/billing" element={<BillingHome />} />
              <Route path="/billing/cancel" element={<BillingCancel />} />
              <Route path="/billing/success" element={<PaymentSuccess />} />
              <Route path="/billing/management" element={<BillingManagement />} />
            </Route>
            <Route path='/' element={<HomePage />} />
            <Route path='/evidence' element={<EvidencePage />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/logout' element={<LogoutPage />} />
            <Route path='/privacy' element={<PrivacyPolicyPage />} />
            <Route path='/cookies' element={<CookiesPolicyPage />} />
            <Route path='/register' element={<RegisterPage />} />
            <Route path='/reset-password' element={<ResetPasswordPage />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
          {/* Chatbot embed – popup mode */}
          <zapier-interfaces-chatbot-embed
            is-popup="true"
            chatbot-id="cmj8lq4eo000bl0xe0cxpt1a5"
          ></zapier-interfaces-chatbot-embed>
          <CookieConsent privacyPolicyPath="/privacy" cookiePolicyPath="/cookies" />
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
